export default "__VITE_ASSET__e8b28c5b__"